import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseURL } from '../../Services/api/baseURL';

export const deliveryZoneRequestApi = createApi({
    reducerPath: 'deliveryZoneRequestApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${baseURL}/api/delivery-zone-request`,
        prepareHeaders: (headers) => {
            const rawToken = localStorage.getItem('token');
            if (rawToken) {
                try {
                    const token = JSON.parse(rawToken);
                    headers.set('authorization', token);
                } catch (e) {
                    headers.set('authorization', rawToken);
                }
            }
            return headers;
        },
    }),
    tagTypes: ['DeliveryZoneRequest'],
    endpoints: (builder) => ({
        // "Notify me" submissions from customers outside current delivery zones.
        getDeliveryZoneRequests: builder.query({
            query: (params) => ({
                url: '/list',
                params,
            }),
            providesTags: ['DeliveryZoneRequest'],
        }),
        markDeliveryZoneNotified: builder.mutation({
            query: (id) => ({
                url: `/${id}/mark-notified`,
                method: 'PATCH',
            }),
            invalidatesTags: ['DeliveryZoneRequest'],
        }),
    }),
});

export const {
    useGetDeliveryZoneRequestsQuery,
    useMarkDeliveryZoneNotifiedMutation,
} = deliveryZoneRequestApi;
